import { TransformedCategory } from './categoryDataTransformers';

export const createHandleCategorySelect =
  (
    categories: TransformedCategory[],
    isSpeakUp: boolean,
    setCategoryName: (value: string) => void,
    setCategoryDescription: (value: string) => void,
    setIsDeterminedCategory: (value: boolean) => void,
    setIsReportedCategory: (value: boolean) => void,
    setCategoryNameTouched: (value: boolean) => void,
    categoryNameTouched: boolean,
  ) =>
  (categoryId: number) => {
    const selectedCategory = categories.find((cat) => cat.id === categoryId);

    if (selectedCategory) {
      setCategoryName(selectedCategory.name);
      setCategoryDescription(selectedCategory.description || '');
      if (isSpeakUp) {
        setIsDeterminedCategory(selectedCategory.isDeterminedCategory);
        setIsReportedCategory(selectedCategory.isReportedCategory);
      }
    }

    if (!categoryNameTouched) {
      setCategoryNameTouched(true);
    }
  };
